import React from "react";
import { ArrowRightAltOutlined } from "@mui/icons-material";
import { Modal } from "antd";
import { ChatMessageType } from "../../interfaces/chats";
import { useAcceptInterviewInviteMutation } from "../../store/chatsSlice";
import "../../css/chats.css";

interface AcceptInterviewModalPropType {
  chat: ChatMessageType;
  closeModal: Function;
  refreshList: Function;
}

function AcceptInterviewModal(props: AcceptInterviewModalPropType) {
  const { chat, closeModal, refreshList } = props;
  const [acceptInterviewInvite] = useAcceptInterviewInviteMutation();

  const onAcceptInterview = () => {
    const payload = {
      isInterviewInviteAccepted: true,
      param: chat?.interviewId ?? "",
    };

    acceptInterviewInvite(payload)
      .unwrap()
      .then((incomingData: any) => {
        refreshList();
        setTimeout(() => {
          closeModal();
        }, 100);
      })
      .catch((err) => {
        console.log("error");
        console.log(err);
      });
  };

  return (
    <Modal
      footer={null}
      visible={true}
      closable={false}
      className="ant-modal"
      onCancel={() => closeModal()}
    >
      <div>
        <div className="accept_interview_invite_header_text">
          <text>Do you really want to accept the invite?</text>
        </div>
        <div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "10px",
            }}
          >
            <ArrowRightAltOutlined
              style={{ width: "28px", height: "28px", paddingRight: "8px" }}
            />
            <text className="accept_interview_invite_modal_text">
              Accepting the invite and not showing up at the interview may hurt
              your profile rank for the future.
            </text>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <ArrowRightAltOutlined
              style={{ width: "28px", height: "28px", paddingRight: "8px" }}
            />
            <text className="accept_interview_invite_modal_text">
              If you want to re-schedule this interview, you can request a new
              time by sending a message.
            </text>
          </div>
        </div>

        <div className="accept_interview_invite_btns_sec">
          <div
            onClick={onAcceptInterview}
            className="accept_interview_invite_btn"
          >
            <text>Accept-I will be on time</text>
          </div>
          <div
            className="message_to_reschedule_btn"
            onClick={() => {
              closeModal();
            }}
          >
            <text className="blue_color_text">Message to Re-Schedule</text>
          </div>
        </div>
      </div>
    </Modal>
  );
}
export default AcceptInterviewModal;
